<template>
    <v-text-field
        clearable
        flat
        hide-details
        v-bind="$attrs"
        v-on="$listeners"
        @input="handleInput"
        color="darken-2"
    ></v-text-field>
</template>

<script>
    export default {
        prop: ['value', 'v-model'],
        data() {
            return {
            };
        },
        methods: {
            handleInput () {
                this.$emit('input', this.value)
            }
        }
    };
</script>

<style>
</style>
